<template>
  <page-wrapper :title="title">
    <juristic-feature-row
      v-for="(item, index) in juristicFeaturesPresenter"
      :key="index"
      v-bind="item"
    ></juristic-feature-row>
  </page-wrapper>
</template>

<script>
import Vue from "vue";
import { baanRueJaiClient } from "@/dependencies";

import PageWrapper from "@/lib/components/PageWrapper";
import JuristicFeatureRow from "../components/JuristicFeatureRow";

export default Vue.extend({
  components: {
    PageWrapper,
    JuristicFeatureRow
  },
  data() {
    const title = "Juristic Features";
    const features = [];

    return { title, features };
  },
  computed: {
    juristicFeaturesPresenter() {
      return this.features.map(feature => {
        const { 
          id,
          title,
          icon_url: iconUrl,
          project_count: projectCount,
          order,
          disable,
          is_all_sc_projects: isAllScProjects,
          is_all_non_sc_projects: isAllNonScProjects
        } = feature;

        let route = undefined;
        if (projectCount !== 'ทุก') {
          route = { name: "JuristicFeatureEditor", params: { id } };
        }

        return {
          title,
          iconUrl,
          projectCount,
          route,
          order,
          disable,
          isAllScProjects,
          isAllNonScProjects
        };
      });
    },
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupJuristicFeatures();
    },
    async setupJuristicFeatures() {
      const {
        features
      } = await this.fetchJuristicFeatures();

      this.features = features;
    },
    async fetchJuristicFeatures() {
      const response = await baanRueJaiClient.admin.juristicFeature.list();

      return response.data.result;
    }
  }
});
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
</style>



// WEBPACK FOOTER //
// src/features/juristic-feature/pages/JuristicFeatureListPage.vue